export const KPI_CONFIG = [
  { key: 'revenuePerformance', label: 'Revenue Performance', category: 'Financial', unit: '$' },

  { key: 'customerSatisfaction', label: 'Customer Satisfaction', category: 'Customer', unit: '%' },
  { key: 'qualityScore', label: 'Quality Score', category: 'Customer', unit: 'pts' },

  { key: 'laborEfficiency', label: 'Labor Efficiency', category: 'Operational', unit: '%' },
  { key: 'serviceResponseTime', label: 'Service Response Time', category: 'Operational', unit: 'min' },
  { key: 'attendanceReliability', label: 'Attendance Reliability', category: 'Operational', unit: '%' },
  { key: 'teamProductivity', label: 'Team Productivity', category: 'Operational', unit: '%' },

  { key: 'goalCompletionRate', label: 'Goal Completion Rate', category: 'Leadership', unit: '%' }
];

export function calculateRollups(managerData, period) {
  const kpiData = managerData.kpis?.[period] || {};
  const attendanceData = managerData.attendance || [];
  const vacationData = managerData.vacations || [];
  const goalMap = managerData.goalMap || managerData.kpiTargets || {};
  const unitMap = managerData.unitMap || managerData.kpiUnits || {};

  // Calculate average KPIs
  const kpis = {};
  const kpiNames = KPI_CONFIG.map(k => k.key);

  kpiNames.forEach(key => {
    const values = kpiData[key] ? Object.values(kpiData[key]) : [];
    const avg = values.length > 0 ? values.reduce((a, b) => a + b, 0) / values.length : 0;
    const rawGoalValue = Number(goalMap[key]);
    const goalValue = Number.isFinite(rawGoalValue) ? rawGoalValue : null;
    const unit = unitMap[key] || '';
    kpis[key] = {
      current: avg,
      target: goalValue,
      actualValue: avg,
      goalValue,
      unit
    };
  });

  // Calculate attendance stats
  const presentDays = attendanceData.filter(d => d.status === 'present').length;
  const absentDays = attendanceData.filter(d => d.status === 'absent').length;
  const lateDays = attendanceData.filter(d => d.status === 'late').length;
  const sickDays = attendanceData.filter(d => d.status === 'sick').length;
  const vacationDays = attendanceData.filter(d => d.status === 'vacation').length;
  const eligibleWorkdays = Math.max(attendanceData.length - vacationDays, 0);
  const plannedLeaveDays = vacationDays;
  const unplannedAbsenceDays = sickDays + absentDays;
  const atWorkDays = Math.max(eligibleWorkdays - unplannedAbsenceDays, 0);
  const atWorkRate = eligibleWorkdays > 0 ? (atWorkDays / eligibleWorkdays) * 100 : 0;

  // Calculate vacation stats
  const usedDays = vacationData
    .filter(v => v.status === 'used')
    .reduce((sum, vacation) => sum + (Number(vacation.days) || 0), 0);
  const scheduledDays = vacationData
    .filter(v => v.status === 'scheduled')
    .reduce((sum, vacation) => sum + (Number(vacation.days) || 0), 0);
  const totalVacationDays = usedDays + scheduledDays;

  // Calculate overall score (0-100)
  let scores = [];
  Object.values(kpis).forEach(kpi => {
    if (Number.isFinite(kpi.target) && kpi.target > 0) {
      const score = Math.min((kpi.current / kpi.target) * 100, 100);
      scores.push(score);
    }
  });
  scores.push(atWorkRate);
  const overallScore = scores.length
    ? Math.round(scores.reduce((a, b) => a + b, 0) / scores.length)
    : 0;

  return {
    kpis,
    atWorkRate,
    totalPresent: presentDays,
    totalAbsent: absentDays,
    totalLate: lateDays,
    totalSick: sickDays,
    totalVacation: vacationDays,
    eligibleWorkdays,
    plannedLeaveDays,
    unplannedAbsenceDays,
    atWorkDays,
    vacationTotal: totalVacationDays,
    vacationUsed: usedDays,
    vacationScheduled: scheduledDays,
    overallScore,
    notes: managerData.notes || ''
  };
}
